import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  rootGrid: {
    display: 'flex',
    height: '100%'
  },
  root: {
    width: 130,
    height: '100%',
    paddingTop: 5,
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: '100vw'
    },
    cursor: 'pointer'
  },
  title: {
    paddingLeft: 3
  },
  dateDayBox: {
    width: 32,
    height: 43,
    '& h2': {
      marginTop: 10
    }
  },
  monthAndYearGrid: {
    width: 80,
    height: 18,
    marginTop: 20,
    marginLeft: 5,
    marginBottom: 4
  },
  chevronsGrid: {
    height: 20,
    marginLeft: 8,
    marginTop: 18
  },
  chevronIcon: {
    color: '#797979',
    fontSize: 21
  },
  errorInvalidFeild: {
    color: 'red'
  }
}))
